import { BaseController } from 'controllers/BaseController'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { GetContext } from 'store/storeUtils'
import {
  IProjectSuppliersAPI,
  ProjectSuppliersAPI,
} from './ProjectSuppliersAPI'

export class ProjectSuppliersController extends BaseController<IProjectSuppliersAPI> {
  constructor() {
    super((onRequestChanged) => {
      const { projectId, partyId } = GetContext()
      return new ProjectSuppliersAPI(partyId, projectId, onRequestChanged)
    })
  }

  public async getSuppliers(workingStepTypeFilter?: WorkingStepType[] | null) {
    try {
      const resp = await this.api.getSuppliers(workingStepTypeFilter)
      return resp
    } catch (err) {
      this.LogError(err)
      throw err
    }
  }
}
